import React from 'react';
import PropTypes from 'prop-types';

import Card from '@components/Card';
import FormalDate from '@components/FormalDate';
import headerPlaceholder from '@assets/images/loading-header.png';
import Rating from '@components/Rating';

import ClientComponents from '@components/ClientComponents';

import Body from './components/Body';
import Content from './components/Content';
import Date from './components/Date';
import Description from './components/Description';
import Title from './components/Title';
import UserImage from './components/UserImage';
import Ratings from './components/Ratings';

function ReviewCard({
  image,
  score,
  name,
  description,
  date,
  speed,
  food,
  service,
  separatorBorder,
  className,
}) {
  return (
    <Card className={className}>
      <UserImage src={image} placeholder={headerPlaceholder} alt={name} />
      <Body separatorBorder={separatorBorder}>
        <Content>
          <Title>
            <div>{name}</div>
            <Rating score={`${score}`} forCard />
          </Title>
          {!!(speed && food && service) && (
            <Ratings speed={speed} food={food} service={service} />
          )}
          <Description>{description}</Description>
          <ClientComponents>
            <FormalDate includeTime value={date}>
              {formattedDate => <Date>{formattedDate}</Date>}
            </FormalDate>
          </ClientComponents>
        </Content>
      </Body>
    </Card>
  );
}

ReviewCard.propTypes = {
  image: PropTypes.string,
  score: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  date: PropTypes.string.isRequired,
  speed: PropTypes.number,
  food: PropTypes.number,
  service: PropTypes.number,
  separatorBorder: PropTypes.bool,
  className: PropTypes.string,
};

ReviewCard.defaultProps = {
  separatorBorder: true,
};

export default ReviewCard;
